<template>
  <button :style="{ backgroundColor: color }">{{ text }}</button>
</template>

<script>
export default {
  name: 'AdmBtn',
  props: {
    text: {
      type: String,
      default: 'text'
    },
    color: {
      type: String,
      default: '#056ac8'
    }
  }
}
</script>

<style scoped>
button {
  border: 0;
  padding: 8px;
  border-radius: 5px;
  color: #FFFFFF;
  cursor: pointer;
  font-weight: bold;
}
</style>
